<template>
  <div class="container footer-slider">
    <!-- <h3>{{$t('home.tradingPlatform.tradingPlatform')}}</h3> -->
    <h3>{{$t('home.Instruments.title')}}</h3>
    <el-carousel :interval="500000" arrow="never" indicator-position="none" height="400px">
      <el-carousel-item key="0">
        <div class="flex" style="flex-direction: column;justify-content: space-between; align-items: center; padding: 0 40px;">
          <div class="left flex flex-column" style="gap:8px;">
            <!-- <p>{{$t('home.Instruments.advan01')}}</p>
            <p>{{$t('home.Instruments.advan02')}}</p>
            <p>{{$t('home.Instruments.advan03')}}</p>
            <p>{{$t('home.Instruments.advan04')}}</p>
            <p>{{$t('home.Instruments.advan05')}}</p>
            <p>{{$t('home.Instruments.advan06')}}</p>
            <p>{{$t('home.Instruments.advan07')}}</p>
            <p>{{$t('home.Instruments.advan08')}}</p>
            <p>{{$t('home.Instruments.advan09')}}</p>
            <p>{{$t('home.Instruments.advan10')}}</p> -->
            <p>{{$t('home.Instruments.advan11')}}</p>
            <p>{{$t('home.Instruments.advan12')}}</p>
            <p>{{$t('home.Instruments.advan13')}}</p>
            <p>{{$t('home.Instruments.advan14')}}</p>
          </div>
          <img class="instruImg" width="467" height="278" src="@/assets/image/home/InstrumentsImg@2x.png" alt="" />
        </div>
      </el-carousel-item>

      <!-- <el-carousel-item key="1">
        <div class="right"></div>
        <h4>{{$t('home.tradingPlatform.service')}} </h4>
        <p>{{$t('home.tradingPlatform.describe')}}</p>
        <div class="box">
          <button class="btn btn-primary" @click="$open('pc')">{{$t('home.tradingPlatform.pc')}}</button>
          <button class="btn btn-primary" @click="$open('mac')">{{$t('home.tradingPlatform.MAC')}}</button>
          <button class="btn" @click="$open('android')" style="margin-right: 5px">{{$t('home.tradingPlatform.android')}}</button>
          <button class="btn" @click="$open('iOS')">{{$t('home.tradingPlatform.ios')}}</button>
        </div>
      </el-carousel-item>
      <el-carousel-item key="2">
        <div class="right right5"></div>
        <h4>{{$t('home.tradingPlatform.service5')}}</h4>
        <p>{{$t('home.tradingPlatform.describe')}}</p>
        <div class="box">
          <button class="btn btn-primary" @click="$open('login5')">{{$t('home.tradingPlatform.pc')}}</button>
          <button class="btn btn-primary" @click="$open('login5')">{{$t('home.tradingPlatform.MAC')}}</button>
          <button class="btn" @click="$open('login5')" style="margin-right: 5px">{{$t('home.tradingPlatform.android')}}</button>
          <button class="btn" @click="$open('login5')">{{$t('home.tradingPlatform.ios')}}</button>
        </div>
      </el-carousel-item> -->
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: 'footer-slider-phone',
}
</script>

<style scoped lang="scss">
  .container{
    width: 100vw;
    padding: 15px 0;
  }
.footer-slider {
  h3 {
    margin-bottom: 18px;
    color: #000;
    font-size: 20px;
    text-align: center;
    margin-top: 12px;
  }
  .el-carousel-item{
    width: 100%;
  }
  .right{
    width: 233.5px;
    height: 139px;
    margin: 0 auto;
    @include bg-image('../../assets/image/home/footer-slider');
    background-size: cover;
  }
  .right5 {
    @include bg-image('../../assets/image/platform/device-MT5');
  }
  h4{
    color: #0D73D6;
    font-size: 18px;
    text-align: center;
    margin-top: 16px;
  }
  p{
    line-height: 20px;
    font-size: 15px;
    color: rgba(0,0,0,0.6);
    position: relative;
    padding-left: 20px;
    &::before {
      content: '';
      position: absolute;
      width: 5px;
      height: 5px;
      background: rgba(0, 0, 0, 0.6);
      top: 8px;
      left: 8px;
      border-radius: 50%;
    }
  }
  .instruImg{
    width: 100%;
    height: auto;
    margin-top: 20px;
  }
  .box{
    width: 100%;
    height: 24px;
    margin-top: 20px;
    text-align: center;
    padding: 0 10%;
    .btn{
      min-width: 120px;
      height: 30px;
      line-height: 30px;
      margin: 5px;
      color: #0D73D6;
    }
    .btn-primary{
      color: #fff;
    }
  }
  /deep/ .el-carousel__indicator--horizontal {
    padding: 12px 7px;
    .el-carousel__button {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: rgba(13, 115, 214, 1);
    }
  }
  //@include bg-image('../../assets/image/home/footer-slider-bg');
}
</style>
